export const ONE_YEAR = 31536000000;
export const THIRTY_MINUTES = 1800000;
export const FIVE_SECONDS = 5000;
